import { StatusIndicatorType } from "ui/atoms/avatar/statusIndicator/interfaces";

export enum ResidentStatusEnum {
  ACTIVE = "active",
  HOSPITALISED = "hospitalised",
  TERMINATED = "terminated",
  DRAFT = "draft",
}
export const StatusTitleMapping: Record<ResidentStatusEnum, string> = {
  [ResidentStatusEnum.ACTIVE]: "Active",
  [ResidentStatusEnum.HOSPITALISED]: "Hospitalised",
  [ResidentStatusEnum.TERMINATED]: "Discharged",
  [ResidentStatusEnum.DRAFT]: "Draft",
};
export const statusTypeOptions = Object.values(ResidentStatusEnum).map(
  (value) => ({
    label: StatusTitleMapping[value],
    value,
  }),
);

export const StatusIndicatorMapping: Record<
  ResidentStatusEnum,
  StatusIndicatorType
> = {
  [ResidentStatusEnum.ACTIVE]: "active",
  [ResidentStatusEnum.HOSPITALISED]: "warning",
  [ResidentStatusEnum.TERMINATED]: "danger",
  [ResidentStatusEnum.DRAFT]: "draft",
};
